import { useState, useEffect } from "react";
import { X, Rocket } from "lucide-react";
import ComingSoonModal from "./ComingSoonModal";

const BANNER_DISMISSED_KEY = "sayitbetter_banner_dismissed";

export default function AnnouncementBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed this session
    const isDismissed = sessionStorage.getItem(BANNER_DISMISSED_KEY);
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem(BANNER_DISMISSED_KEY, "true");
  };

  const handleEarlyAccess = () => {
    setShowComingSoon(true);
  };

  if (!isVisible) return null;

  return (
    <>
      <div 
        className="sticky top-0 z-50 w-full bg-[#4FB3A5] text-white shadow-md"
        data-testid="announcement-banner"
      >
        <div className="max-w-7xl mx-auto px-4 py-3 sm:py-2.5">
          <div className="flex items-center justify-between gap-3">
            {/* Content */}
            <div className="flex-1 flex flex-col sm:flex-row items-start sm:items-center justify-center gap-2 sm:gap-4">
              <p className="text-sm sm:text-base font-medium leading-snug text-center sm:text-left">
                <span className="hidden sm:inline">🚀 </span>
                <Rocket className="inline-block sm:hidden w-4 h-4 mr-1 -mt-0.5" />
                SayItBetter is officially launching soon. Join for early access, founding-member perks, and Pro features.
              </p>
              
              {/* CTA Button */}
              <button
                onClick={handleEarlyAccess}
                data-testid="early-access-btn"
                className="inline-flex items-center justify-center whitespace-nowrap bg-[#1F3A5F] hover:bg-[#2a4a75] text-white text-sm font-semibold px-4 py-2 rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
              >
                Get Early Access
              </button>
            </div>

            {/* Close Button */}
            <button
              onClick={handleDismiss}
              data-testid="banner-close-btn"
              className="flex-shrink-0 p-1.5 rounded-full hover:bg-white/20 transition-colors duration-200"
              aria-label="Dismiss banner"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      </div>
      
      <ComingSoonModal 
        isOpen={showComingSoon} 
        onClose={() => setShowComingSoon(false)} 
      />
    </>
  );
}
